import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * @file useSelectPopover
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { useCallback, useEffect, useState } from 'react';
import { useSelectInstance } from '../context/select';
export function useSelectPopover(ref) {
  var select = useSelectInstance();

  var _useState = useState(select.searchQuery),
      _useState2 = _slicedToArray(_useState, 2),
      query = _useState2[0],
      onQueryChange = _useState2[1];

  var _useState3 = useState(select.getShowOptionsIdSort().length <= 0),
      _useState4 = _slicedToArray(_useState3, 2),
      isEmpty = _useState4[0],
      setIsEmpty = _useState4[1];

  useEffect(function () {
    select.addListener('query-change', onQueryChange);
    return function () {
      select.removeListener('query-change', onQueryChange);
    };
  }, []);
  var setQuery = useCallback(function (q) {
    return select.setQuery(q);
  }, []);
  useEffect(function () {
    var panel = ref.current;

    if (!panel) {
      return;
    }

    var options = [].slice.call(panel.querySelectorAll('[data-type=select-option]')).sort(function (a, b) {
      var code = a.compareDocumentPosition(b);
      return code & 8 ? -1 : code & 16 ? 1 : code & 4 ? -1 : code & 2 ? 1 : 0;
    });
    var ids = options.map(function (item) {
      return item.getAttribute('data-option-id') || '';
    }).filter(function (id) {
      return !!id;
    });
    select.updateOptionIdSort(ids);
    setIsEmpty(select.getShowOptionsIdSort().length <= 0);
  });
  return {
    query: query,
    setQuery: setQuery,
    isEmpty: isEmpty
  };
}